export function maskEmail(str: string, n: number): string {
  if (n <= 0 || n > str.length) {
    return str; // 마스킹할 문자 수가 0보다 작거나, 문자열 길이보다 크면 원본 문자열 반환
  }

  const maskedPart = "*".repeat(n);
  const unmaskedPart = str.slice(0, -n);
  return unmaskedPart + maskedPart;
}
